import { ApolloProvider } from '@apollo/client/react';

import { FourOhOneKContributionsEditView } from '../features/employees/four-oh-one-k/FourOhOneKContributionsEditView';
import { client } from '../graphql/client';
import { IdempotencyProviderWithFeatureRegistry } from '../providers/IdempotencyProviderWithFeatureRegistry';
import { CurrentEmployeeContext } from '../utils/currentEmployee';
import { CurrentEmployerContext } from '../utils/currentEmployer';

export const FourOhOneKContributionsEditViewApp = ({
  employerId,
  employeeId,
  employeeName,
  isEnrolledInAutoEscalation,
  hasOutboundPayrollIntegration,
  payrollProviderName,
}: {
  employerId: string;
  employeeId: string;
  employeeName: string;
  isEnrolledInAutoEscalation: boolean;
  hasOutboundPayrollIntegration: boolean;
  payrollProviderName: string;
}) => (
  <ApolloProvider client={client}>
    <IdempotencyProviderWithFeatureRegistry featureName="employees">
      <CurrentEmployerContext.Provider value={employerId}>
        <CurrentEmployeeContext.Provider value={employeeId}>
          <FourOhOneKContributionsEditView
            employeeName={employeeName}
            isEnrolledInAutoEscalation={isEnrolledInAutoEscalation}
            hasOutboundPayrollIntegration={hasOutboundPayrollIntegration}
            payrollProviderName={payrollProviderName}
          />
        </CurrentEmployeeContext.Provider>
      </CurrentEmployerContext.Provider>
    </IdempotencyProviderWithFeatureRegistry>
  </ApolloProvider>
);
